var map = {
	"./bet365.png": 7082,
	"./d.png": 4017,
	"./doxxbet.png": 7925,
	"./fortuna.png": 5854,
	"./nike.png": 5726,
	"./pinnacle.png": 593,
	"./synottip.png": 1291,
	"./tipos.png": 3624,
	"./tipsport.png": 1046
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 770;